export default "__VITE_ASSET__869a6e7e__"